// extracted by mini-css-extract-plugin
export var root = "GenericTeam-root-LoCka";
export var rootAuthor = "GenericTeam-root_author-KslKW";
export var rootAuthorImage = "GenericTeam-root_authorImage-0yjD5";
export var rootAuthorName = "GenericTeam-root_authorName-t0mJ0";
export var rootAuthorPicture = "GenericTeam-root_authorPicture-rZhE4";
export var rootAuthorRole = "GenericTeam-root_authorRole-FaW97";
export var rootAuthorsWrapper = "GenericTeam-root_authorsWrapper-DqIW5";
export var rootAuthorsWrapperCenter = "GenericTeam-root_authorsWrapper-center-eQlMK";
export var rootButton = "GenericTeam-root_button-VugW9";
export var rootHeading = "GenericTeam-root_heading-rEKTL";
export var rootMobileHidden = "GenericTeam-root-mobileHidden-IsF5T";
export var rootRow = "GenericTeam-root_row-PFmdb";